<script>
	module.exports = {
		props: ['article', 'routeContext', 'assessment'],
		components: {
			'video-content': require('components/video-content.vue').default
		}
	};
</script>
<template>
	<div
		class="video-tab"
		:class="{ wrapper: assessment }">
		<div class="large-8 columns">
			<video-content
				:video="article.video"
				:auth="true">
			</video-content>
		</div>
		<div class="large-4 columns print-hidden">
			<article-aside
				:article="article"
				:search-query-string="routeContext.parsedPath.getQueryParam('search')">
			</article-aside>
		</div>
	</div>
</template>
